import {
  GeoJSONObject,
  MapContext as MapContextI,
  MapPopupInfo,
  ResourceLocation,
} from '@dispatch/shared/types';
import * as React from 'react';

export const MapContext = React.createContext<MapContextI | undefined>(
  undefined
);

function MapProvider({ children }: { children: React.ReactNode }) {
  const [popupInfo, setPopupInfo] = React.useState<MapPopupInfo | null>(null);
  const [showTaskDetails, setShowTaskDetails] = React.useState<{
    show: boolean;
    claimNumber: string | null;
  }>({ show: false, claimNumber: null });
  const [mapMarkers, setMapMarkers] = React.useState<JSX.Element[] | []>([]);
  const [geoJson, setGeoJson] = React.useState<GeoJSONObject[]>([]);
  const [resourceLocationGeoJson, setResourceLocationGeoJson] = React.useState<{
    starting?: ResourceLocation;
    working?: ResourceLocation[];
  }>({});
  const [showResourceLocationLayer, setShowResourceLocationLayer] =
    React.useState<boolean>(false);
  const [selectedResourceId, setSelectedResourceId] = React.useState<string>();

  const value = {
    mapMarkers,
    setMapMarkers,
    popupInfo,
    setPopupInfo,
    showTaskDetails,
    setShowTaskDetails,
    geoJson,
    setGeoJson,
    resourceLocationGeoJson,
    setResourceLocationGeoJson,
    showResourceLocationLayer,
    setShowResourceLocationLayer,
    selectedResourceId,
    setSelectedResourceId,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
}

function useMap() {
  const context = React.useContext(MapContext);
  if (context === undefined) {
    throw new Error('useMap must be used within a MapProvider');
  }
  return context;
}

export { MapProvider, useMap };
